export const sendmailConstants = {
    SENDMAIL_ACTION_TYPES: {
        SEND_MAIL_REQUEST: 'SEND_MAIL_REQUEST',
        SEND_MAIL_FAILURE: 'SEND_MAIL_FAILURE',
        SEND_MAIL_SUCCESS: 'SEND_MAIL_SUCCESS',
    },
};
